import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input } from 'reactstrap';
import { Field } from './Field';
import Combobox from './Combobox';
import { TimeFrame, getTimeFrameName, TimeFrameIsSelectable } from '../../../../utils/Order/Order';
import { useEffect, useState } from 'react';

const Booktype = ({onChange, booktypes, booktype, readonly, balancetype, onAccountChange}) => {
const [itemsBook,setItemsBook] = useState([])
const [itemsBalance, setItemsBalance] = useState([])

useEffect(() => {
    let bookItems = []
    booktypes.forEach((item) => {
        bookItems.push({id: item.BooktypeName, description: item.BooktypeFriendlyName})
    })
    setItemsBook(bookItems)
}, [booktypes])

useEffect(() => {
  const book = booktypes.filter((a) => a.BooktypeName == booktype)[0];
  if (book){
  let balanceItems = []
  book.BalanceType.forEach((bt) => {
    balanceItems.push({id: bt.BalanceTypeName, description: bt.BalanceTypeDescription})
  })
  setItemsBalance(balanceItems)
  }
}, [booktypes, booktype])

const handleBooktypeChange = (value) => {
  onChange({ BookType: value });
  const selectedBook = booktypes.find(item => item.BooktypeName === value);
  if (selectedBook && selectedBook.BalanceType.length > 0) {
    onAccountChange({ 'BalanceType': selectedBook.BalanceType[0].BalanceTypeName });
  } else {
    onAccountChange({ 'BalanceType': '' });
  }
};

  return (
    <div>
    {(booktypes && booktypes.length > 0) &&
      <Row>
        <Col lg={6}>
          <Field label={'Book Type'} >
            <Combobox 
              value={booktype}
              items={itemsBook}
              disabled={readonly.BookType}
              onChange={handleBooktypeChange}
              placeholder={'Book Type'}
            />
          </Field>
        </Col>
        <Col lg={6}>
          <Field label={'Balance Type'} >
            <Combobox 
              value={balancetype}
              items={itemsBalance}
              disabled={readonly.BookType}
              onChange={(v) => onAccountChange({'BalanceType': v})}
              placeholder={'Balance Type'}
            />
          </Field>
        </Col>
      </Row>
    }
    </div>
  )
}

export default Booktype;